import {handleError} from './helpers'
import apiServiceGenerator from "@/api/selectableGenerator";

export default function (endpoint) {

    const pending = {};

    return {
        state: {
            selectListLoading: false,
            selectListPager: {},
            selectListAdditional: {},
            selectList: [],
            service: apiServiceGenerator(endpoint),
            selectListCache: {}
        },
        getters: {
            selectListLoading: function (state) {
                return !!state.selectListLoading
            },
            selectListPager: function (state) {
                return JSON.parse(JSON.stringify(state.selectListPager))
            },
            selectAdditional: function (state) {
                return JSON.parse(JSON.stringify(state.selectAdditional))
            },
            selectList: function (state) {
                return state.selectList
            },
        },
        mutations: {
            'SET_SELECT_LIST_LOADING': function (state, boolean = true) {
                state.selectListLoading = boolean
            },

            'SET_SELECT_LIST': function (state, list) {
                state.selectList = list
            },

            'SET_SELECT_LIST_PAGER': function (state, pager = {}) {
                state.selectListPager = pager
            },

            'SET_SELECT_LIST_ADDITIONAL': function (state, data = {}) {
                state.selectListAdditional = data
            },

            'ADD_TO_SELECT_LIST_CACHE': function (state, {key, result}) {
                state.selectListCache[key] = {
                    result: result.data,
                    additional: result.additional,
                    meta: result.data
                };
            },
        },
        actions: {
            selectList: function ({commit, state}, filters) {
                commit('app/SET_LOADING', true, {root: true});
                commit('SET_SELECT_LIST_LOADING', true);

                const filterKey = (filters ? ((filters) => {
                    return JSON.stringify(Object.keys(filters).sort().reduce((acc, key) => {
                        acc[key] = filters[key];
                        return acc;
                    }, {}))
                })(filters) : 'empty') || 'empty';

                if (state.selectListCache[filterKey]) {
                    return state.selectListCache[filterKey];
                }

                if (pending[filterKey]) {
                    return pending[filterKey];
                }

                const request = state.service.fetchSelectList(filters).then(response => {
                    commit('SET_SELECT_LIST', response.data);
                    commit('SET_SELECT_LIST_PAGER', response.meta);
                    commit('SET_SELECT_LIST_ADDITIONAL', response.additional);
                    commit('ADD_TO_SELECT_LIST_CACHE', {key: filterKey, result: response});
                    return response.data;
                }).catch((e) => {
                    delete pending[filterKey];
                    return handleError(e, commit);
                }).finally(() => {
                    commit('app/SET_LOADING', false, {root: true});
                    commit('SET_SELECT_LIST_LOADING', false);
                });

                pending[filterKey] = request;

                return request;
            }
        }
    }
}